var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: _vm.fill,
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M14 7.81561C14.0023 8.69552 13.7967 9.56353 13.4 10.3489C12.9296 11.2901 12.2065 12.0817 11.3116 12.6351C10.4168 13.1885 9.3855 13.4819 8.33333 13.4823C7.45342 13.4846 6.58541 13.279 5.8 12.8823L2 14.1489L3.26667 10.3489C2.86995 9.56353 2.66437 8.69552 2.66667 7.81561C2.66707 6.76345 2.96041 5.73218 3.51381 4.83731C4.06722 3.94244 4.85884 3.21932 5.8 2.74894C6.58541 2.35223 7.45342 2.14665 8.33333 2.14894H8.66667C10.0562 2.22561 11.3687 2.81212 12.3528 3.79618C13.3368 4.78025 13.9233 6.09271 14 7.48228V7.81561Z",
          stroke: _vm.stroke,
          "stroke-width": "1.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }